<template>
  <div v-if="body != null">
    <div class="lp_page" v-html="body"></div>
  </div>
  <div v-else-if="isNotFound">
    <NotFound />
  </div>
</template>

<script>
import { GET_PAGE_LP_PREVIEW } from '@/store/pageLp/actions'
import NotFound from '@/components/404.vue'

export default {
  name: 'PageLpPreview',
  components: {
    NotFound
  },
  data () {
    return {
      code: this.$route.params.code || '',
      body: null,
      isNotFound: false
    }
  },
  computed: {
    paramsCode () {
      return this.$route.params.code || ''
    }
  },
  methods: {
    getPageLpPreview () {
      const params = { agent: this.$route.query.agent }
      this.$store.dispatch(GET_PAGE_LP_PREVIEW, {
        code: this.code,
        params: { params: params }
      })
        .then((data) => {
          this.body = data.body
          // eslint-disable-next-line
          $('title').html(data.title + ' - ' + data.page_title)
        })
        .catch((error) => {
          if (error.errorStatus === 401) {
            this.$router.pushIsses('/')
          } else if (error.errorStatus === 404) {
            this.isNotFound = true
          }
        })
    }
  },
  created () {
    this.getPageLpPreview()
  },
  mounted () {
    // eslint-disable-next-line
    $('title').html('')
  },
  watch: {
    paramsCode (val, old) {
      this.code = val
      this.title = ''
      this.body = null
      this.isNotFound = false
      this.getPageLpPreview()
    }
  }
}
</script>
